var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-container",style:({ height: _vm.height , width: _vm.width }),attrs:{"src":_vm.url,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }